type getPublicNameUserType = {
  formatted_name?: string
  first_name?: string
  last_name?: string
  name?: string
  is_suspended?: boolean
  banned?: boolean
}

export function getPublicName(user: getPublicNameUserType | undefined | null) {
  if (!user) {
    return ""
  }
  if (user.is_suspended || user.banned) {
    return "Hank Member"
  }
  const { formatted_name, first_name, last_name, name } = user
  let publicName = formatted_name

  // Construct name from first_name and last_name if available
  // This ensures we show the full name even if formatted_name is incomplete
  if (first_name && last_name) {
    // If last name is short (1-2 chars), show it fully, otherwise show initial
    const lastNameDisplay = last_name.length <= 2 ? last_name : last_name[0]
    publicName = `${first_name} ${lastNameDisplay}`
  } else if (!publicName) {
    if (first_name) {
      publicName = first_name
    } else if (name) {
      publicName = name
    } else {
      publicName = ""
    }
  }
  return ["Hank T", ""].includes(publicName) ? "Hank" : publicName
}

export function formatOrdinal(number: number) {
  switch (number) {
    case 11:
    case 12:
    case 13:
      return `${number}th`
  }

  const lastDigit = number % 10
  switch (lastDigit) {
    case 1:
      return `${number}st`
    case 2:
      return `${number}nd`
    case 3:
      return `${number}rd`
    default:
      return `${number}th`
  }
}
